import { svg } from "config/svgStyles";

export const carousel = () => ({
  width: "100%",
  display: "flex",
  justifyContent: "center",
  position: "relative",
});

export const carouselScrollContainer =
  ({ disableScroll }) =>
  ({ isDesktop }) => ({
    margin: !isDesktop ? "0" : "0 70px 0",
    padding: !isDesktop ? "20px 10px" : "20px 0 20px 20px",
    display: "flex",

    overflowX: disableScroll ? "hidden" : "auto",
    scrollPadding: !isDesktop ? "0 10px" : "0 20px",
    scrollSnapType: "x mandatory",
    scrollBehavior: "smooth",
    overscrollBehavior: "contain",

    "&::-webkit-scrollbar": {
      display: "none",
    },
  });

export const carouselItem =
  ({ scrollSnapAlign }) =>
  ({ isDesktop }) => ({
    marginRight: !isDesktop ? "10px" : "20px",
    flexShrink: 0,
    scrollSnapAlign,
    scrollMargin: !isDesktop ? "0 10px" : "0 20px",
  });

export const leftCarouselArrow = ({ isDesktop }) => ({
  width: !isDesktop ? "42px" : "60px",
  height: !isDesktop ? "40px" : "60px",
  position: "absolute",
  left: !isDesktop ? "0" : "60px",
  top: "50%",
  transform: "translate(-2px, -50%)",
  border: "2px solid white",
  borderRadius: !isDesktop ? "0 20px 20px 0" : "50%",
  cursor: "pointer",
});

export const leftCarouselArrowIcon = {
  position: "absolute",
  left: "50%",
  top: "50%",
  transform: "translate(-50%, -50%)",
  ...svg("white"),
};

export const rightCarouselArrow = ({ isDesktop }) => ({
  width: !isDesktop ? "42px" : "60px",
  height: !isDesktop ? "40px" : "60px",
  position: "absolute",
  right: !isDesktop ? "0" : "40px",
  top: "50%",
  transform: "translate(2px, -50%)",
  border: "2px solid white",
  borderRadius: !isDesktop ? "20px 0 0 20px" : "50%",
  cursor: "pointer",
});

export const rightCarouselArrowIcon = {
  position: "absolute",
  left: "50%",
  top: "50%",
  transform: "translate(-50%, -50%)",
  ...svg("white"),
};
